import * as React from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";

type UseQueryStringOptions = {
  parseOptions?: queryString.ParseOptions;
  stringifyOptions?: queryString.StringifyOptions;
  /** Use replace instead of push so filter sync does not stack history or fight with callers that use replace. */
  replace?: boolean;
  /**
   * Custom equality for whether the URL already matches (e.g. canonical parse/stringify
   * so key order and string-vs-array do not cause replace loops).
   */
  compareSearch?: (current: string, next: string) => boolean;
};

export default function useQueryString<T>(options?: UseQueryStringOptions) {
  const location = useLocation(),
    history = useHistory();

  const search = queryString.parse(location.search, options?.parseOptions);

  const sameSearch = (next: string) => {
    if (options?.compareSearch) {
      return options.compareSearch(location.search, next);
    }
    return location.search === next;
  };

  const update = (e: T) => {
    // @ts-ignore
    const qs = queryString.stringify(e, options?.stringifyOptions);
    const next = qs ? `?${qs}` : "";
    if (sameSearch(next)) return;
    if (options?.replace) {
      history.replace({ search: next });
    } else {
      history.push({ search: next });
    }
  };

  return { search, update };
}
